import { Formatter } from '@ribajs/core'
import { formatMoney } from '../../gen-2/lib/money'

/**
 * Formats the price based on the shop's HTML with currency setting (if the format is not overwritten by passing a format parameter).
 * @param cents
 * @param format
 *
 * @see https://github.com/NathanPJF/deploybot-shopify/blob/master/assets/ajaxify.js.liquid
 * @see https://github.com/discolabs/cartjs/blob/master/src/utils.coffee
 * @see https://github.com/JumpLinkNetwork/shopify-productjs/blob/master/src/utilities.js
 * @see https://help.shopify.com/en/themes/liquid/filters/money-filters
 */
export const moneyFormatter: Formatter = {
  name: 'money',
  read(cents: string | number | undefined | null) {
    if (cents === undefined || cents === null) {
      return ''
    }

    let parsedCents: number | undefined

    if (typeof cents !== 'number') {
      parsedCents = parseFloat(cents)
    } else {
      parsedCents = cents
    }

    if (isNaN(parsedCents)) {
      console.error(`money formatter: could not parse cents value "${cents}"`)
      return ''
    }

    return formatMoney(parsedCents)
  },
}
